import "whatwg-fetch";

import * as React from "react";
import * as ReactDOM from "react-dom";

import { AppContainer } from "react-hot-loader";
import App from "./App";

//Navigation is always visible, import common stuff here
import "../shared/vendorCss"
import "../../../Content/Site.less"


const rootContainer = document.getElementById("navigationbar");
if (rootContainer) {
    const render = (Component: React.FC) => ReactDOM.render((
        <AppContainer>
            <Component {...(rootContainer.dataset)}  />
        </AppContainer>
    ), rootContainer);
    render(App);
    if (module.hot) {
        module.hot.accept("./App", () => {
            const NextApp: React.FC = require("./App");
            render(NextApp);
        });
    }
}
